import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import type { AuthRole } from "../types/auth";

interface PrivateRouteProps {
  role?: AuthRole;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ role }) => {
  const { isAuthenticated, role: currentRole } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role && currentRole !== role) {
    return <Navigate to={currentRole === "student" ? "/student/courses" : "/courses"} replace />;
  }
  return <Outlet />;
};

export default PrivateRoute;
